var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetStarted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5 18C38.5 27.9414 29.9937 36 19.5 36C9.0063 36 0.5 27.9414 0.5 18C0.5 8.0586 9.0063 0 19.5 0C29.9937 0 38.5 8.0586 38.5 18ZM25.2 12.6C25.2 14.0322 24.5995 15.4057 23.5305 16.4184C22.4616 17.4311 21.0117 18 19.5 18C17.9883 18 16.5384 17.4311 15.4695 16.4184C14.4005 15.4057 13.8 14.0322 13.8 12.6C13.8 11.1678 14.4005 9.79432 15.4695 8.78162C16.5384 7.76893 17.9883 7.2 19.5 7.2C21.0117 7.2 22.4616 7.76893 23.5305 8.78162C24.5995 9.79432 25.2 11.1678 25.2 12.6ZM19.5 33.3C22.7609 33.305 25.9463 32.3702 28.6333 30.6198C29.7809 29.8728 30.2711 28.4508 29.6023 27.2934C28.221 24.894 25.371 23.4 19.5 23.4C13.629 23.4 10.779 24.894 9.3958 27.2934C8.7289 28.4508 9.2191 29.8728 10.3667 30.6198C13.0537 32.3702 16.2391 33.305 19.5 33.3Z",
    fill: "#22428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStarted);
export default __webpack_public_path__ + "static/media/get-started.94e4a9e71b39342398028b727caf99da.svg";
export { ForwardRef as ReactComponent };